import { IClientsResponse } from 'types/clients';
import api from '../services/config/api';

export const createClient = (data: IClientsResponse) => api.post<IClientsResponse>('/client', data);
